import 'reflect-metadata';
import React, { PropsWithChildren } from 'react';
import * as Sentry from '@sentry/browser';
import {
  CurrentLangContext,
  DateFormatterContext,
  DateService
} from '@unitedtraders/utex-site-common';
import type { VisitCollector } from '@unitedtraders/visit-collector';

import { iocContext } from '@hooks/useInject';
import type { AppConfig } from '@type/AppConfig';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { ZendeskButton } from '@components/ZendeskButton';
import { createIOC } from './bindings/browser';
import { iocNames } from './iocNames';
import { getConfig } from './configs/getConfig';

const { version } = require('../package.json');

declare global {
  interface Window {
    gtm: any;
  }
}

const ioc = createIOC();

// eslint-disable-next-line no-console
console.groupCollapsed('Application dizraptor-web started');
// eslint-disable-next-line no-console
console.info(`APP VERSION: ${version}`);
// eslint-disable-next-line no-console
console.groupEnd();

window._ioc = ioc;
window._iocNames = iocNames;

const dateService = ioc.get<DateService>(iocNames.dateService);
const appConfig = ioc.get<AppConfig>(iocNames.appConfig);

if (appConfig.googleTagManager && window.gtm) {
  window.gtm(window, document, 'script', 'dataLayer', appConfig.googleTagManager);
}

ioc.get<VisitCollector>(iocNames.visitCollector);
ioc.get(iocNames.authModalService);

export const ClientEntrypoint = ({ children }: PropsWithChildren) => {
  const config = getConfig();

  const { sentryDSN } = config;
  const currentLanguage = 'en';

  if (sentryDSN) {
    Sentry.init({
      dsn: sentryDSN,
      environment: 'Client'
    });
  }
  return (
    <iocContext.Provider value={ioc}>
      <DateFormatterContext.Provider value={dateService}>
        <CurrentLangContext.Provider value={{ currentLanguage }}>
          <ErrorBoundary>
            <ZendeskButton />
            {children}
          </ErrorBoundary>
        </CurrentLangContext.Provider>
      </DateFormatterContext.Provider>
    </iocContext.Provider>
  );
};
